"use strict";
/* eslint-disable @typescript-eslint/naming-convention */
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFamilyField = void 0;
/** Resolve a legacy string field name or a full FormField into a FormField */
const LEGACY_FIELD_MAP = {
    name: { key: 'name', label: 'Name', type: 'text' },
    mobile: { key: 'mobile', label: 'Mobile', type: 'phone' },
    email: { key: 'email', label: 'Email', type: 'email' },
    occupation: { key: 'occupation', label: 'Occupation', type: 'text' },
    dateOfBirth: { key: 'dateOfBirth', label: 'Date of Birth', type: 'date' },
};
function resolveFamilyField(field) {
    if (typeof field === 'string') {
        return LEGACY_FIELD_MAP[field] || { key: field, label: field, type: 'text' };
    }
    return field;
}
exports.resolveFamilyField = resolveFamilyField;
